import { render, staticRenderFns } from "./inventoryDeals.vue?vue&type=template&id=51dbc377&lang=pug"
import script from "./inventoryDeals.vue?vue&type=script&lang=js"
export * from "./inventoryDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports